import { getPercent } from '@/shared/lib/getPercent';
import { Status } from '@/shared/types/Status';

import {
  PROJECT_CREATED_TO_UPLOADING_SEC,
  TRANSCRIPTION_SEC,
  TRANSCRIPTION_TO_VOICE_SUGGESTING_SEC,
  TRANSLATION_SEC,
  VIDEO_UPLOADED_TO_TRANSCRIPTION_SEC,
  VIDEO_UPLOADING_SEC,
  VOICE_SUGGESTING_SEC,
  VOICE_SUGGESTING_TO_TRANSLATION_SEC,
} from './mlAverageTasksDurations';

export const VIDEO_UPLOADING_SEC_FOR_60_SEC_VIDEO =
  PROJECT_CREATED_TO_UPLOADING_SEC +
  VIDEO_UPLOADING_SEC +
  VIDEO_UPLOADED_TO_TRANSCRIPTION_SEC +
  TRANSCRIPTION_SEC +
  TRANSCRIPTION_TO_VOICE_SUGGESTING_SEC +
  VOICE_SUGGESTING_SEC +
  VOICE_SUGGESTING_TO_TRANSLATION_SEC +
  TRANSLATION_SEC;
const INITIAL_PERCENT = 1;
const FINAL_PERCENT = 99;
// Рассчитанные начальные проценты для каждого статуса загрузки видео
const PROJECT_UPLOADING_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC,
  VIDEO_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const PROJECT_UPLOADED_TO_TRANSCRIPTION_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC + VIDEO_UPLOADING_SEC,
  VIDEO_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const PROJECT_TRANSCRIPTION_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC + VIDEO_UPLOADING_SEC + VIDEO_UPLOADED_TO_TRANSCRIPTION_SEC,
  VIDEO_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const PROJECT_TRANSCRIPTION_TO_VOICE_SUGGESTING_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC + VIDEO_UPLOADING_SEC + VIDEO_UPLOADED_TO_TRANSCRIPTION_SEC + TRANSCRIPTION_SEC,
  VIDEO_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const PROJECT_SUGGEST_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_TRANSCRIPTION_SEC +
    TRANSCRIPTION_SEC +
    TRANSCRIPTION_TO_VOICE_SUGGESTING_SEC,
  VIDEO_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const PROJECT_SUGGEST_TO_TRANSLATION_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_TRANSCRIPTION_SEC +
    TRANSCRIPTION_SEC +
    TRANSCRIPTION_TO_VOICE_SUGGESTING_SEC +
    VOICE_SUGGESTING_SEC,
  VIDEO_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const PROJECT_TRANSLATION_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_TRANSCRIPTION_SEC +
    TRANSCRIPTION_SEC +
    TRANSCRIPTION_TO_VOICE_SUGGESTING_SEC +
    VOICE_SUGGESTING_SEC +
    VOICE_SUGGESTING_TO_TRANSLATION_SEC,
  VIDEO_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
// Константы для загрузки видео
export const VIDEO_UPLOADING_TASKS_SEC: {
  [key in Status]?: number;
} = {
  [Status.created]: PROJECT_CREATED_TO_UPLOADING_SEC,
  [Status.transcriptionDone]: TRANSCRIPTION_TO_VOICE_SUGGESTING_SEC,
  [Status.transcriptionStarted]: TRANSCRIPTION_SEC,
  [Status.translationStarted]: TRANSLATION_SEC,
  [Status.uploaded]: VIDEO_UPLOADED_TO_TRANSCRIPTION_SEC,
  [Status.uploading]: VIDEO_UPLOADING_SEC,
  [Status.voiceSuggestDone]: VOICE_SUGGESTING_TO_TRANSLATION_SEC,
  [Status.voiceSuggestStarted]: VOICE_SUGGESTING_SEC,
};
export const INITIAL_PERCENT_FOR_UPLOADING_VIDEO_STATUS: {
  [key in Status]?: number;
} = {
  [Status.created]: INITIAL_PERCENT,
  [Status.transcriptionDone]: PROJECT_TRANSCRIPTION_TO_VOICE_SUGGESTING_INITIAL_PERCENT,
  [Status.transcriptionStarted]: PROJECT_TRANSCRIPTION_INITIAL_PERCENT,
  [Status.translationStarted]: PROJECT_TRANSLATION_INITIAL_PERCENT, // 94
  [Status.uploaded]: PROJECT_UPLOADED_TO_TRANSCRIPTION_INITIAL_PERCENT,
  [Status.uploading]: PROJECT_UPLOADING_INITIAL_PERCENT,
  [Status.voiceSuggestDone]: PROJECT_SUGGEST_TO_TRANSLATION_INITIAL_PERCENT,
  [Status.voiceSuggestStarted]: PROJECT_SUGGEST_INITIAL_PERCENT,
};
export const FINAL_PERCENT_FOR_UPLOADING_VIDEO_STATUS: {
  [key in Status]?: number;
} = {
  [Status.created]: PROJECT_UPLOADING_INITIAL_PERCENT,
  [Status.transcriptionDone]: PROJECT_SUGGEST_INITIAL_PERCENT,
  [Status.transcriptionStarted]: PROJECT_TRANSCRIPTION_TO_VOICE_SUGGESTING_INITIAL_PERCENT,
  [Status.translationStarted]: FINAL_PERCENT, // 99
  [Status.uploaded]: PROJECT_TRANSCRIPTION_INITIAL_PERCENT,
  [Status.uploading]: PROJECT_UPLOADED_TO_TRANSCRIPTION_INITIAL_PERCENT,
  [Status.voiceSuggestDone]: PROJECT_TRANSLATION_INITIAL_PERCENT,
  [Status.voiceSuggestStarted]: PROJECT_SUGGEST_TO_TRANSLATION_INITIAL_PERCENT,
};
